import React from 'react';
import { QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import CheckBox from '../CheckBox';

export type SuppliersPermissionsFormFields = {
  canAccessSuppliers: boolean;
};

const SuppliersPermissions = () => {
  const { t } = useTranslation();
  return (
    <QStack direction={['column']}>
      <CheckBox
        data-cy="permission-checkbox"
        name="canAccessSuppliers"
        label="suppliers access"
        text={t('forms.permissions.accessSuppliers')}
      />
    </QStack>
  );
};

export default SuppliersPermissions;
